import nexo from '@tiendanube/nexo';

const instance = nexo.create({
  clientId: '9791',
  log: true,
});

export default instance;
